import { booleanAttribute, Component, input } from '@angular/core';

/**
 * Display-only date picker for previews and read-only layouts.
 */
@Component({
  selector: 'fb-date-picker-display',
  templateUrl: './date-picker-display.html',
  styleUrl: './date-picker-display.scss',
  host: { '[attr.data-muted]': 'muted()' },
})
export class DatePickerDisplay {
  /**
   * A text that describes the purpose of the date picker.
   */
  public readonly label = input.required();

  /**
   * Placeholder text shown when {@link text} is empty.
   */
  public readonly placeholder = input('MM/DD/YYYY');

  /**
   * Enables muted (grayed-out) visual styling.
   */
  public readonly muted = input(false, { transform: booleanAttribute });

  /**
   * The text to display.
   */
  public readonly text = input('');

  /**
   * Whether the placeholder should be rendered when the field is empty.
   */
  public readonly showPlaceholder = input(true, { transform: booleanAttribute });
}
